import { render, staticRenderFns } from "./PopupLogin.vue?vue&type=template&id=5a1836ab&scoped=true&"
import script from "./PopupLogin.vue?vue&type=script&lang=js&"
export * from "./PopupLogin.vue?vue&type=script&lang=js&"
import style0 from "./PopupLogin.vue?vue&type=style&index=0&id=5a1836ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1836ab",
  null
  
)

export default component.exports